import { apiRequest } from './client';

/** Customer dashboard configuration (SRS #124). */

const BASE = '/api/v1/enterprise/reports/dashboard-config';
const TOKEN_KEY = 'policyora_token';
const opts = (extra: RequestInit = {}): RequestInit => {
  const token = localStorage.getItem(TOKEN_KEY);
  return { ...extra, headers: { 'Content-Type': 'application/json', ...(token ? { Authorization: `Bearer ${token}` } : {}), ...(extra.headers || {}) } };
};

export type DashboardTab = 'dashboard' | 'trending' | 'chart' | 'all' | 'newsletters' | 'alerts';
export type DashboardWidget = 'coverage' | 'kpis' | 'analysis' | 'recent' | 'coming_into_force' | 'team_activity';
export interface DashboardConfig {
  workspace_name: string | null; accent: string | null; welcome_note: string | null;
  landing_tab: DashboardTab; tabs: DashboardTab[]; widgets: Record<DashboardWidget, boolean>;
  default_filters: { jurisdictions: string[]; date_range: '30d' | '90d' | '1y' | 'all' };
  pinned_regulations: string[];
}
export interface Permitted {
  tabs: { key: DashboardTab; label: string; allowed: boolean; requires: string | null }[];
  widgets: { key: DashboardWidget; label: string; allowed: boolean; requires: string | null }[];
  date_ranges: string[];
}
export interface DashboardConfigResponse { config: DashboardConfig; permitted: Permitted; stored: DashboardConfig; can_edit: boolean; owner_email: string }

let cache: { at: number; data: DashboardConfigResponse } | null = null;
export async function getDashboardConfig(force = false): Promise<DashboardConfigResponse> {
  if (!force && cache && Date.now() - cache.at < 2 * 60_000) return cache.data;
  const data = await apiRequest<DashboardConfigResponse>(BASE, opts());
  cache = { at: Date.now(), data };
  return data;
}
export const invalidateDashboardConfig = () => { cache = null; };
export async function putDashboardConfig(cfg: Partial<DashboardConfig>): Promise<{ config: DashboardConfig; stored: DashboardConfig }> {
  const r = await apiRequest<{ config: DashboardConfig; stored: DashboardConfig }>(BASE, opts({ method: 'PUT', body: JSON.stringify(cfg) }));
  cache = null;
  return r;
}
export async function resetDashboardConfig(): Promise<{ config: DashboardConfig }> {
  const r = await apiRequest<{ config: DashboardConfig }>(BASE, opts({ method: 'DELETE' }));
  cache = null;
  return r;
}
